module.exports = {
  REACT_APP_API_URL: process.env.REACT_APP_API_URL ?? "https://atlas.danckuts.com/api",
};
